import { render, staticRenderFns } from "./ShowTeamPositionsSlide.vue?vue&type=template&id=0b834aac"
import script from "./ShowTeamPositionsSlide.vue?vue&type=script&lang=js"
export * from "./ShowTeamPositionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b834aac')) {
      api.createRecord('0b834aac', component.options)
    } else {
      api.reload('0b834aac', component.options)
    }
    module.hot.accept("./ShowTeamPositionsSlide.vue?vue&type=template&id=0b834aac", function () {
      api.rerender('0b834aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ShowTeamPositionsSlide.vue"
export default component.exports